/** @jsx jsx */
import { Button, Flex, jsx } from 'theme-ui';
import React from 'react';

import { useTranslate } from '@modules';
import { Paragraph, Link, SubTitle, SvgIcon } from '@core';
import { FinnoscoreBannerProps } from './FinnoscoreBannerProps';
import { styles } from './MobileFinnoscoreBanner.styles';

export const MobileFinnoscoreBanner = ({ link, onClick, ...props }: FinnoscoreBannerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const __ = useTranslate();

  return <Flex variant="flex.col" sx={styles.box} {...props}>
    <Button variant="buttons.pure" sx={styles.titleButton} onClick={() => setIsOpen(!isOpen)}>
      <Flex variant="flex.rowCenter" sx={styles.titleBox}>
        <SubTitle sx={styles.title}>{__('finnoscoreBanner.title')}</SubTitle>
        {isOpen
          ? <Button variant="buttons.pure" onClick={onClick}><SvgIcon sx={styles.closeIcon} name="close" /></Button>
          : <SvgIcon sx={styles.openArrow} name="tailedArrow" />}
      </Flex>
    </Button>
    <Flex sx={styles.content(isOpen)}>
      <Paragraph sx={styles.paragraph}>{__('finnoscoreBanner.paragraph')}</Paragraph>
      <Button variant="buttons.cta" onClick={onClick}>
        <Link sx={styles.link} to={link}>{__('finnoscoreBanner.button')}</Link>
      </Button>
    </Flex>
  </Flex>;
};
